import script from "./AccountCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountCreate.vue?vue&type=script&setup=true&lang=js"

import "./AccountCreate.vue?vue&type=style&index=0&id=1dd5eb44&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd5eb44"]])

export default __exports__